import React from 'react';
import { Loader2, ClipboardList } from 'lucide-react';

const ACTION_LABELS = {
  view_ambassadors: { label: 'View Ambassadors', color: 'text-blue-400 bg-blue-500/10 border-blue-500/20' },
  export_ambassadors_csv: { label: 'Export Ambassadors CSV', color: 'text-amber-400 bg-amber-500/10 border-amber-500/20' },
  view_payments: { label: 'View Payments', color: 'text-blue-400 bg-blue-500/10 border-blue-500/20' },
  export_payments_csv: { label: 'Export Payments CSV', color: 'text-amber-400 bg-amber-500/10 border-amber-500/20' },
  view_subscriptions: { label: 'View Subscriptions', color: 'text-blue-400 bg-blue-500/10 border-blue-500/20' },
  export_subscriptions_csv: { label: 'Export Subs CSV', color: 'text-amber-400 bg-amber-500/10 border-amber-500/20' },
  view_paystack_events: { label: 'View Paystack Events', color: 'text-blue-400 bg-blue-500/10 border-blue-500/20' },
  export_paystack_events_csv: { label: 'Export Events CSV', color: 'text-amber-400 bg-amber-500/10 border-amber-500/20' },
  view_storage_overview: { label: 'View Storage', color: 'text-cyan-400 bg-cyan-500/10 border-cyan-500/20' },
};

export const AuditTab = ({ rows, loading }) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-16">
        <Loader2 className="w-6 h-6 animate-spin text-[var(--isp-body)]" />
        <span className="ml-2 text-[var(--isp-body)]">Loading audit log...</span>
      </div>
    );
  }
  if (!rows.length) {
    return (
      <div className="text-center py-16 text-[var(--isp-body)]">
        <ClipboardList className="w-10 h-10 mx-auto mb-3 opacity-30" />
        <p className="font-semibold text-white">No audit entries yet</p>
        <p className="text-sm mt-1">Admin actions will appear here as they occur.</p>
      </div>
    );
  }

  return (
    <div className="space-y-3" data-testid="audit-log-list">
      {rows.map((entry) => {
        const meta = ACTION_LABELS[entry.action] || { label: entry.action, color: 'text-slate-400 bg-slate-500/10 border-slate-500/20' };
        const ts = new Date(entry.timestamp);
        return (
          <div key={`${entry.action}-${entry.timestamp}`} className="flex items-start gap-4 rounded-xl border border-[var(--isp-glass-border)] bg-slate-900/60 p-4">
            <div className="flex-shrink-0 mt-0.5">
              <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${meta.color} border`}>
                <ClipboardList className="w-4 h-4" />
              </div>
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <span className={`text-xs font-semibold px-2 py-0.5 rounded-md border ${meta.color}`}>
                  {meta.label}
                </span>
                <span className="text-xs text-[var(--isp-muted)]">
                  {ts.toLocaleDateString()} {ts.toLocaleTimeString()}
                </span>
              </div>
              <p className="text-sm text-[var(--isp-body)] mt-1">
                <span className="text-white font-medium">{entry.email}</span>
                {entry.name && <span className="text-[var(--isp-muted)]"> ({entry.name})</span>}
              </p>
              {entry.details && (
                <p className="text-xs text-[var(--isp-muted)] mt-0.5">{entry.details}</p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
